import { render, staticRenderFns } from "./GenerateQRCode.vue?vue&type=template&id=507c51a2"
import script from "./GenerateQRCode.vue?vue&type=script&lang=js"
export * from "./GenerateQRCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports